import { DisplayData, RequirementMatches as RequirementMatchesType } from "types/campaign/applications"

interface RequirementMatchesProps {
    requirement_match: string,
    requirement_match_details: DisplayData,
    requirement_matches: RequirementMatchesType,
}
const RequirementMatches: React.FC<RequirementMatchesProps>= ({requirement_match, requirement_match_details, requirement_matches}) => {
  return (
    <div className='detail-card border-1'>
            <div className="detail-card-header d-flex justify-content-between align-items-center">
                Criteria Match 
                <span className="detail-card-header-text-right">{requirement_match}%</span>
            </div>
            <div className="detail-card-body p-3">
                <div className="row g-1">
                    {
                        Object.values(requirement_matches).map((requirement, i) => (
                            <div className="col-12 col-md-6 criteria-match" key={i}>
                                {
                                    requirement.match ? (
                                        <span><i className="ri-checkbox-circle-fill text-success"></i></span>
                                    ) : (
                                        <span><i className="ri-close-circle-fill text-danger"></i></span>
                                    )
                                }
                                <span className="ms-2">{requirement.name}</span>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
  )
}

export default RequirementMatches